<template>
    <div>
        <div class="hipaa-container">
            <!-- Header -->
            <div class="hipaa-header">
                <h3 class="hipaa-title">{{ $t('modals.patient_profile.profile.hippa_detail.head') }}</h3>
                <span class="active-form-badge">{{ $t('modals.patient_profile.profile.hippa_detail.active') }}</span>
            </div>

            <!-- Card -->
            <div class="hipaa-card">
                <div class="main">
                    <div class="hipaa-card-header">
                        <h4 class="hipaa-title">{{ $t('modals.patient_profile.profile.hippa_detail.header.title') }}</h4>
                        <span class="status-active">
                            {{ $t('modals.patient_profile.profile.hippa_detail.header.active') }}
                        </span>
                    </div>
                    <div class="hipaa-actions">
                        <button class="btn-view">
                            <common-icon name="view" size="medium"></common-icon>
                            {{ $t('modals.patient_profile.profile.hippa_detail.button.view') }}
                        </button>
                        <button class="btn-download">
                            <common-icon name="download" size="medium"></common-icon>
                            {{ $t('modals.patient_profile.profile.hippa_detail.button.download') }}
                        </button>
                    </div>
                </div>
                <div class="hipaa-details">
                    <div class="hipaa-left">
                        <div class="main-data">
                            <p class="file">{{ $t('modals.patient_profile.profile.hippa_detail.file.file_title') }}</p>
                            <p class="file-detail">{{ $t('modals.patient_profile.profile.hippa_detail.file.title') }}</p>
                        </div>
                        <div class="main-data">
                            <p class="file">{{ $t('modals.patient_profile.profile.hippa_detail.file.upload_title') }}</p>
                            <p class="file-detail">{{ $t('modals.patient_profile.profile.hippa_detail.file.upload') }}</p>
                        </div>
                        <p class="scope-tags">
                            <strong>Scope:</strong>
                            {{ $t('modals.patient_profile.profile.hippa_detail.file.scope') }}
                        </p>
                        <span class="scope-tag">
                            {{ $t('modals.patient_profile.profile.hippa_detail.file.provide') }}
                        </span>
                    </div>

                    <div class="hipaa-right">
                        <div class="main-data">
                            <p class="file">{{ $t('modals.patient_profile.profile.hippa_detail.file.size_title') }}</p>
                            <p class="file-detail">{{ $t('modals.patient_profile.profile.hippa_detail.file.size') }}</p>
                        </div>
                        <div class="main-data">
                            <p class="file">{{ $t('modals.patient_profile.profile.hippa_detail.file.expires_title') }}</p>
                            <p class="file-detail">
                                {{ $t('modals.patient_profile.profile.hippa_detail.file.expires') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Upload Section -->
        <div class="upload-container">
            <h3 class="hipaa-title">{{ $t('modals.patient_profile.profile.hippa_detail.upload.head') }}</h3>
            <form-wrapper class="practice-information-form">
                <form-row>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.hipaa.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.hipaa.insurance_plans.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.hipaa.document.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.hipaa.document.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            type="date"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.hipaa.provider.label') }}
                        </label>
                        <text-field
                            :placeholder="$t('forms.patient_profile.fields.hipaa.provider.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="memberId"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <label class="form-field__label">
                            {{ $t('forms.patient_profile.fields.hipaa.comment.label') }}
                        </label>
                        <select-input
                            class="schedule-apply__input"
                            :placeholder="$t('forms.patient_profile.fields.hipaa.comment.placeholder')"
                            :hasAutofocus="true"
                            :options="locationOptions"
                            @change="changeCurrentLocationId($event)"
                        ></select-input>
                    </form-cell>
                </form-row>
            </form-wrapper>

            <!-- Upload Box -->
            <div class="upload-Box">
                <div class="upload-icon">
                    <common-icon name="chose" size="extra-large"></common-icon>
                </div>
                <p class="upload-text">{{ $t('modals.patient_profile.profile.hippa_detail.upload.drop_text') }}</p>
                <p class="upload-subtext">{{ $t('modals.patient_profile.profile.hippa_detail.upload.subtext') }}</p>
                <div class="upload-subtitle">
                    <button>
                        <common-icon name="chose" size="small"></common-icon>
                        Choose file
                    </button>
                    <input type="file" class="upload-file-text" />
                </div>
            </div>

            <!-- Buttons -->
            <div class="button-row">
                <button class="upload-btn">
                    <common-icon name="insure" size="medium"></common-icon>
                    {{ $t('modals.patient_profile.profile.hippa_detail.upload.button') }}
                </button>
                <button class="down">
                    <common-icon name="navigation" size="medium"></common-icon>
                    {{ $t('modals.patient_profile.profile.hippa_detail.upload.download') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'

    export default {
        name: 'request-records-form',
        mixins: [FormMixin, HandleRequestMixin],
        data() {
            return {
                locationOptions: [],
            }
        },
    }
</script>

<style scoped>
    .hipaa-container {
        border-bottom: 1px solid #ddd;
    }
    .hipaa-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
    .hipaa-title {
        font-size: 18px;
        font-weight: 500;
        color: oklch(0.145 0 0);
        margin: 10px 0;
    }
    .active-form-badge {
        font-size: 12px;
        background: #eef2ff;
        color: #1e40af;
        padding: 3px 8px;
        border-radius: 6px;
        font-weight: 500;
    }
    .hipaa-card {
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 16px;
        background: #fff;
        margin-bottom: 30px;
    }
    .hipaa-card-header {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .status-active {
        font-size: 12px;
        background: #d1fae5;
        color: #065f46;
        padding: 2px 6px;
        border-radius: 4px;
        text-transform: capitalize;
    }
    .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 12px;
    }
    .hipaa-actions {
        display: flex;
        gap: 8px;
    }
    .btn-view,
    .btn-download {
        font-size: 13px;
        border: 1px solid #ddd;
        background: #fff;
        padding: 6px 10px;
        border-radius: 6px;
        cursor: pointer;
    }
    .hipaa-details {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 58%;
    }
    .main-data {
        display: flex;
        margin-bottom: 0;
    }
    .file {
        color: oklch(0.446 0.03 256.802);
        font-weight: 500;
        font-size: 14px;
        margin-right: 8px;
    }
    .file-detail {
        font-size: 12px;
        margin: 4px 0;
        color: #333;
    }
    .scope-tags {
        font-size: 12px;
        color: oklch(0.145 0 0);
        font-weight: 500;
        display: flex;
        align-items: center;
    }
    .scope-tag {
        display: inline-block;
        margin-top: 6px;
        font-size: 12px;
        border: 1px solid #e9ebef;
        padding: 6px;
        border-radius: 4px;
        color: oklch(0.145 0 0);
        font-weight: 500;
    }
    .upload-container {
        margin-top: 20px;
    }
    .upload-Box {
        margin-top: 20px;
    }
    .upload-subtitle {
        position: relative;
    }
    .upload-subtitle button {
        position: absolute;
        left: 3px;
        top: -21px;
        width: 131px;
        background: #fff;
        z-index: 9;
    }
    .upload-file-text {
        position: absolute;
        left: 2px;
        bottom: -11px;
        border: 1px solid #ddd;
        width: 138px;
        padding: 7px;
        border-radius: 10px;
    }
    .upload-btn {
        background: oklch(0.627 0.194 149.214);
        border: none;
        opacity: 0.5;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        padding: 10px 18px;
        border-radius: 6px;
        cursor: pointer;
    }
    .button-row {
        text-align: start;
        margin: 15px 0;
    }
    .down {
        color: oklch(0.546 0.245 262.881);
        margin-left: 14px;
        font-size: 12px;
    }
    .btn-view:hover,
    .btn-download:hover {
        background-color: #e9ebef !important;
    }
    @media screen and (max-width: 600px) {
        .card-headers,
        .main {
            display: block !important;
        }
    }
</style>
